import {each, isObj} from './lang'
import { queryBlackKeyList } from '../../constant'

var Query = {
  /**
   * url解析
   * @param  {string} url 需要解析的url，默认当前url
   * @return {obj}        返回包含host, url参数params, port...等属性值的对象字面量
   */
  decode: function (url) {
    url = url || window.location.href
    var a = document.createElement('a')
    a.href = url
    return {
      source: url,
      protocol: a.protocol.replace(':', ''),
      host: a.hostname,
      port: a.port,
      query: a.search,
      params: (function () {
        var ret = {},
            seg = a.search.replace(/^\?/, '').split('&'),
            len = seg.length, i = 0, s
        for (;i < len; i++) {
          if (!seg[i]) { continue }
          s = seg[i].split('=')
          ret[decodeURIComponent(s[0])] = decodeURIComponent(seg[i].substr(s[0].length + 1))
        }
        return ret
      })(),
      hashParams: (function () {
        var ret = {},
            seg = [],
            hash = (a.hash && a.hash.indexOf('?') > -1) ? a.hash.replace(/^#.+\?/, '').split('&') : [],
            // eslint-disable-next-line no-redeclare
            seg = seg.concat(hash),
            len = seg.length, i = 0, s

        for (;i < len; i++) {
          if (!seg[i]) { continue }
          s = seg[i].split('=')
          ret[decodeURIComponent(s[0])] = decodeURIComponent(seg[i].substr(s[0].length + 1))
        }
        return ret
      })(),
      file: (a.pathname.match(/\/([^/?#]+)$/i) || [, ''])[1],
      hash: a.hash.replace('#', ''),
      path: a.pathname.replace(/^([^/])/, '/$1'),
      relative: (a.href.match(/tps?:\/\/[^/]+(.+)/) || [, ''])[1],
      segments: a.pathname.replace(/^\//, '').split('/')
    }
  },
  /**
   * 构建url
   * @param  {obj} data Query.decode解析后返回的obj
   * @return {string}   完整的url
   */
  encode: function (data) {
    var ret = [], query = []

    ret.push(data.protocol, '://')
    ret.push(data.host)
    if (data.port) {
      ret.push(':', data.port)
    }
    ret.push(data.path)
    each(data.params, function (val, key) {
      if (val !== null) {
        query.push(encodeURIComponent(key) + '=' + encodeURIComponent(val))
      }
    })
    if (query.length > 0) {
      ret.push('?', query.join('&'))
    }
    if (data.hash) {
      ret.push('#', data.hash)
    }
    return ret.join('')
  },

  /**
   * 获取url参数
   * @param  {string} keys  查询的url参数名，多个参数逗号隔开
   * @param  {[type]} url   需要解析的url, 默认当前url
   * @return {string | obj} 查询的参数值：一个参数返回参数值；多个参数返回obj
   */
  get: function (keys, url, config) {
    if (arguments.length === 0) {
      return Query.decode()
    }

    var ret = {},
        keysArr = keys.split(','),
        data = Query.decode(url || window.location.href)

    var paramsKey = config && config.fromHash ? 'hashParams' : 'params'

    each(keysArr, function (key, i) {
      if (data[paramsKey][key]) {
        if (keysArr.length === 1) {
          ret = data[paramsKey][key]
          return false
        } else {
          ret[key] = data[paramsKey][key]
        }
      } else {
        if (keysArr.length === 1) {
          ret = null
          return false
        } else {
          ret[key] = null
        }
      }
    })
    return ret
  },

  urlParams (obj, isEncode) {
    isEncode = isEncode !== false
    let url = ''

    if (isObj(obj)) {
      for (var k in obj) {
        let value = obj[k] !== undefined ? obj[k] : ''
        url += '&' + k + '=' + (isEncode ? encodeURIComponent(value) : value)
      }
    }
    return url ? url.substring(1) : ''
  },

  /**
   * 添加url参数
   * @param  {string} url    所需添加参数的url
   * @param  {obj}    params 添加的参数obj
   * @return {string}        添加参数后的url
   */
  build: function (url, params) {
    var data = Query.decode(url)

    each(params || {}, function (val, key) {
      data.params[key] = val
    })

    return Query.encode(data)
  },

  buildMp (url, params = {}) {
    const paramsStr = Query.urlParams(params)
    const separator = paramsStr
      ? url.indexOf('?') > -1
        ? '&' : '?'
      : ''
    return `${url}${separator}${paramsStr}`
  },

  constructUrl: function (url, params) {
    var obj = {}
    var hkCityId = 357
    var p1 = Query.decode(url)
    var p2 = Query.decode(window.location.href)

    var blackList = ['debug', 'id']

    // 过滤黑名单
    each(p2.params || {}, function (val, key) {
      if (blackList.indexOf(key) === -1) {
        obj[key] = val
      }
    })

    each(p1.params || {}, function (val, key) {
      if (blackList.indexOf(key) === -1) {
        obj[key] = val
      }
    })

    // 保证lang cityid直接透传
    if (obj.lang && obj.cityid) {
      // 多语言，lang，cityid 兜底逻辑
      let lang = obj.lang
      obj.cityid = parseInt(obj.cityid)
      let twReg = /^886500[0-9]{3}$/
      if (obj.lang === 'zh-TW' || twReg.test(obj.cityid)) {
        lang = 'zh-TW'
      }
      if (obj.lang === 'zh-HK' || obj.cityid === hkCityId) {
        lang = 'zh-HK'
      }
      obj.lang = lang
    }

    each(params || {}, function (val, key) {
      obj[key] = val
    })

    p1.params = obj
    return Query.encode(p1)
  },

  weixin: function (url, params) {
    return Query.build(url, params)
  },
  https: function (url) {
    return url.replace(/^http:/, '')
  },

  // get别名，用法同get方法
  query: function (key) {
    if (key) {
      return Query.get(key)
    }
    return Query.decode().params
  },
  hashQuery: function (key) {
    if (key) {
      return Query.get(key, '', {fromHash: true})
    }
    return Query.decode().hashParams
  },
  // 获取可以传递给下个页面的参数
  getPassQuery: function (query) {
    // 过滤一些敏感参数;
    const urlParams = query || {...Query.decode().params, ...Query.decode().hashParams}
    for (let key in urlParams) {
      if (queryBlackKeyList.indexOf(key) > -1) {
        delete urlParams[key]
      }
    }
    return urlParams
  }
}

export default Query
